export default {
    text: {
        title: 'Texte',
        addText: 'Nouveau texte',
        fontFamily: 'Famille de caractères',
        fontSize: 'Font size',
        textAlignment: 'Alignement du texte',
        fontColor: 'Couleur de police',
        lineSpacing: 'Espace entre les lignes',
        arialSerif: 'Arial (sans-serif)',
        verdanaSansSerif: 'Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (sans-serif)',
        trebuchetMSSansSerif: 'Trebuchet MS (sans-serif)',
        timesNewRomanSerif: 'Times New Roman (avec empattement)',
        georgiaSerif: 'Georgie (serif)',
        garamondSerif: 'Garamond (empattement)',
        courierNewMonospace: 'Courrier New (espacement fixe)',
        brushScriptMTCursive: 'Escriture au pinceau MT (cursive)',
        backgroundColor: 'Couleur de fond',
    },
};
